import { useQPSearch } from "../useQPSearch";
import { ListMode } from "./ListMode";
import { SearchMode } from "./SearchMode";

export const MediaTable = () => {
  const { searchState } = useQPSearch();

  return searchState ? <SearchMode /> : <ListMode />;
};
